// @mui
import { SvgIcon } from "@mui/material";

function MedicalCallIcon(props) {
  return (
    <SvgIcon
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      sx={{
        fill: "transparent",
        "& path": {
          stroke: (theme) => theme.palette.common.white,
        },
      }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.95331 14.0458C13.1232 17.2147 14.0659 13.3249 16.0838 15.3418C18.0297 17.2877 19.1486 17.6768 16.6831 20.1423C16.3737 20.3894 14.4123 23.3763 7.51707 16.4821C0.621836 9.58878 3.60487 7.62441 3.85297 7.31599C6.32424 4.84472 6.70661 5.96944 8.65346 7.91435C10.6704 9.93223 6.78347 10.877 9.95331 14.0458Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2232 10.7509C16.7283 11.4476 18.5681 11.1781 19.8096 9.93658C21.3955 8.35069 21.3984 5.77726 19.8096 4.18942C18.2237 2.60353 15.6474 2.60353 14.0615 4.18942C12.82 5.43089 12.5515 7.27072 13.2471 8.77586C13.3366 8.99769 12.9387 10.4367 13.25 10.748C13.5623 11.0603 15.0004 10.6614 15.2232 10.7509Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9355 8.22863V5.89844"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0978 7.0625H15.7715"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default MedicalCallIcon;
